// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","month":"month-2ArR3 month-3_c1h","week":"week-3JYtP","week_withPrice":"week_withPrice-2TJhv"};